export default __webpack_public_path__ + "static/media/assap.af5b5a7d.svg";